import { apiClient } from '@/lib/api/client'

export interface ActivityArtist {
  id: number
  name: string
  email: string
  lastLogin: string | null
  lastSeen: string | null
  /** Catalog provider whose onboarding created the account, e.g. 'pictufy'. */
  partner: string | null
  /** A partner account nobody has signed in to: catalog, not an artist. */
  catalogOnly: boolean
  lastAction: string | null
  lastActionAt: string | null
  artworks: number
  published: number
  sessions: number
  uploads: number
  actions: number
  features: string[]
}

export interface ActivityReport {
  generatedAt: string
  coverageStartedAt: string
  timezone: string
  days: number
  total: number
  summary: {
    /** Enabled artist accounts, excluding catalog-only partner accounts. */
    totalArtists: number
    partnerAccounts: number
    claimedPartners: number
    partnerProviders: string[]
    active7Days: number
    active30Days: number
    activeInPeriod: number
    returningArtists: number
    uploads: number
    uploaders: number
    sessions: number
    totalArtworks: number
    publishedArtworks: number
    publishedInPeriod: number
    catalogArtworks: number
    catalogPublished: number
  }
  artists: ActivityArtist[]
  features: { feature: string; artists: number; actions: number }[]
  trend: ActivityDay[]
  rhythm: { dow: number; hour: number; events: number; artists: number }[]
  recent: ActivityEvent[]
  leaders: ActivityLeader[]
}

export interface ActivityDay { day: string; active: number; uploads: number; sessions: number; actions: number }

export interface ActivityEvent {
  id: number
  artistId: number
  name: string
  event: string
  feature: string
  source: 'browser' | 'api'
  occurredAt: string
}

export interface ActivityLeader { id: number; name: string; sessions: number; uploads: number; actions: number; features: number }

export type ActivityAudience = 'artists' | 'partners' | 'all'

export async function getActivityReport(days: number, search: string, offset: number, limit = 50, audience: ActivityAudience = 'artists'): Promise<ActivityReport> {
  const { data } = await apiClient.get<ActivityReport>('/api/admin/artist-activity', {
    params: { days, search, offset, limit, audience },
  })
  return data
}
